/* import __COLOCATED_TEMPLATE__ from './default-value.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();